import { render } from "./NoteVideoAttach.vue?vue&type=template&id=05c5f02c&scoped=true"
import script from "./NoteVideoAttach.vue?vue&type=script&lang=js"
export * from "./NoteVideoAttach.vue?vue&type=script&lang=js"

import "./NoteVideoAttach.vue?vue&type=style&index=0&id=05c5f02c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c5f02c"]])

export default __exports__